import type { IconDef } from '../types';

export const tick: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M9.40517 22.2835C9.17517 22.2835 8.95517 22.2035 8.78517 22.0635L1.37517 16.1335C0.94517 15.7935 0.87517 15.1635 1.21517 14.7235C1.56517 14.2935 2.18517 14.2235 2.62517 14.5635L9.20517 19.8235L21.1752 2.92354C21.4952 2.47354 22.1152 2.36354 22.5652 2.68354C23.0152 3.00354 23.1252 3.62354 22.8052 4.07354L10.2152 21.8635C10.0552 22.0835 9.81517 22.2335 9.53517 22.2735C9.48517 22.2735 9.44517 22.2735 9.39517 22.2735L9.40517 22.2835Z',
    },
  ],
};
